import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators'

import { ProfileService } from '../services/profile.service';

@Injectable({
    providedIn: 'root'
  })

export class ValidateUniqueEmail {

    constructor(
        private profileService: ProfileService,
    ){}

    createValidator(sub_user_id: number) {

        return (control: AbstractControl) => {

            let data = { action: 'check', user_email: control.value, sub_user_id: sub_user_id }

            return this.profileService.Useremailcheck(data).
                pipe(
                    map(res => {
                        return res.status ? null : { emailTaken: true };
                    })
                )
        };
    }
}